<template>
  <TableParcelType />
</template>
<script>
import TableParcelType from "./components/tableParcelType";
export default {
  components: {
    TableParcelType,
  },
};
</script>
